export const USER_TYPE = {
  USER: "user",
  CREATOR_LITE_OLD: "creatorLite",
  CREATOR_LITE: "creator lite",
  CREATOR: "creator",
  ORG_ADMIN: "orgAdmin",
  ADMINISTRATOR: "administrator",
  STORYDOC_ADMIN: "storydoc admin",
} as const;
